export default "__VITE_ASSET__95f90e61__"